// Per-user "recently opened patients" for the search palette. Stored in
// localStorage, namespaced by the logged-in user, capped, and wiped on logout
// (see lib/auth.js + the logout buttons in Layout/PatientLayout).
const PREFIX = 'ss:recentPatients:'
const CAP = 8

const keyFor = (userKey) => PREFIX + (userKey || 'anon')

function read(userKey) {
  try { const a = JSON.parse(localStorage.getItem(keyFor(userKey)) || '[]'); return Array.isArray(a) ? a : [] }
  catch { return [] }
}
function write(userKey, arr) {
  try { localStorage.setItem(keyFor(userKey), JSON.stringify(arr.slice(0, CAP))) } catch { /* private mode / quota */ }
}

export function getRecentPatients(userKey, limit = 3) {
  return read(userKey).slice(0, limit)
}

// Push a patient to the front (move-to-front dedupe), storing just enough to
// render the row without a refetch.
export function addRecentPatient(userKey, p) {
  const id = p?.id ?? p?.patient_id
  if (!userKey || id == null) return
  const entry = {
    id,
    prefix: p.prefix || '', name: p.name || '', surname: p.surname || '',
    nickname: p.nickname || '', fullname: p.fullname || '',
    hn: p.hn || p.HN || '', phone: p.phone || p.tel || '',
    branch_name: p.branch_name || p.branch?.name || '',
  }
  write(userKey, [entry, ...read(userKey).filter((x) => String(x.id) !== String(id))])
}

export function removeRecentPatient(userKey, id) {
  write(userKey, read(userKey).filter((x) => String(x.id) !== String(id)))
}

export function clearRecentPatients(userKey) {
  try { localStorage.removeItem(keyFor(userKey)) } catch { /* ignore */ }
}

// Wipe EVERY user's list — used on logout, where we may not know the active key.
export function clearAllRecentPatients() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i)
      if (k && k.startsWith(PREFIX)) localStorage.removeItem(k)
    }
  } catch { /* ignore */ }
}
